export const isLinkPaymentMethod = (paymentMethod?: {
  isLink?: boolean;
  card?: { brand?: string };
}): boolean => !!paymentMethod?.isLink || paymentMethod?.card?.brand === "link";
